import type { PaletteColor } from '@hrms/shared'
import type { ReactNode } from 'react'
import { cn } from '../../lib/cn.ts'

export interface ChipProps {
  color: PaletteColor
  dot?: boolean
  className?: string
  children: ReactNode
}

/** Category chip: pill in the palette colour. */
export function Chip({ color, dot, className, children }: ChipProps) {
  return (
    <span
      data-color={color}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full bg-cb px-[9px] py-0.5 text-[12.5px] leading-[1.4] font-medium whitespace-nowrap text-cf',
        className,
      )}
    >
      {dot && <span aria-hidden className="size-1.5 rounded-full bg-current" />}
      {children}
    </span>
  )
}
